import { Link } from '@mui/material';
import { GoMotoComponent } from '../../../API/GoMoto.types';
import { BaseLinkProps } from './BaseLink.types';

/**
 * The base MUI link control to create a mockable base component for unit testing.
 *
 * @param children - {@link BaseLinkProps children} description.
 * @param props - {@link BaseLinkProps props} description.
 */
export const BaseLink: GoMotoComponent<BaseLinkProps> = ({
    children,
    ...props
}) => {
    return (
        <Link {...props}>
            {children}
        </Link>
    );
};